import { IState } from 'legacy/lut/store'

export const selectAssortmentState = (state: IState) => state.partner360.assortment
